"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalloutVariant = exports.isCalloutVariant = exports.getVariantAccent = exports.CALLOUT_VARIANT_LABEL = exports.CALLOUT_VARIANTS = exports.VARIANT_ICONS = exports.VARIANT_TITLE = exports.DEFAULT_VARIANT = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const notebook_1_1 = tslib_1.__importDefault(require("iconista/lib/react/lineicons/notebook-1"));
const lightbulb_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/lightbulb"));
const triangle_alert_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/triangle-alert"));
const octagon_alert_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/octagon-alert"));
const star_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/star"));
const quote_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/quote"));
const noteIconClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    '& path': { fill: 'currentColor' },
});
const NoteIcon = (props) => (React.createElement("span", { className: noteIconClass },
    React.createElement(notebook_1_1.default, { width: 16, height: 16, ...props })));
const TipIcon = (props) => React.createElement(lightbulb_1.default, { width: 16, height: 16, ...props });
const WarningIcon = (props) => (React.createElement(triangle_alert_1.default, { width: 16, height: 16, ...props }));
const DangerIcon = (props) => (React.createElement(octagon_alert_1.default, { width: 16, height: 16, ...props }));
const ImportantIcon = (props) => (React.createElement(star_1.default, { width: 16, height: 16, ...props }));
const QuoteIcon = (props) => (React.createElement(quote_1.default, { width: 16, height: 16, ...props }));
exports.DEFAULT_VARIANT = 'note';
/** Title rendered when the element's `title` is unset (auto mode). */
exports.VARIANT_TITLE = {
    note: 'Note',
    tip: 'Tip',
    warning: 'Warning',
    danger: 'Danger',
    important: 'Important',
    quote: 'Quote',
};
/** Iconista components rendered when the user has not set a custom `icon`. */
exports.VARIANT_ICONS = {
    note: NoteIcon,
    tip: TipIcon,
    warning: WarningIcon,
    danger: DangerIcon,
    important: ImportantIcon,
    quote: QuoteIcon,
};
exports.CALLOUT_VARIANTS = ['note', 'tip', 'warning', 'danger', 'important', 'quote'];
exports.CALLOUT_VARIANT_LABEL = {
    note: 'Note',
    tip: 'Tip',
    warning: 'Warning',
    danger: 'Danger',
    important: 'Important',
    quote: 'Quote',
};
/** Resolve the accent color for a semantic callout variant. */
const getVariantAccent = (styles, variant) => {
    switch (variant) {
        case 'note':
            return styles.info + '';
        case 'tip':
            return styles.positive + '';
        case 'warning':
            return styles.warning + '';
        case 'danger':
            return styles.negative + '';
        case 'important':
            return styles.important + '';
        case 'quote':
            return styles.grey + '';
    }
};
exports.getVariantAccent = getVariantAccent;
const isCalloutVariant = (v) => v === 'note' || v === 'tip' || v === 'warning' || v === 'danger' || v === 'important' || v === 'quote';
exports.isCalloutVariant = isCalloutVariant;
const getCalloutVariant = (v) => ((0, exports.isCalloutVariant)(v) ? v : exports.DEFAULT_VARIANT);
exports.getCalloutVariant = getCalloutVariant;
